import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationReportChannel, NotificationReportCreation, NotificationReportStatus } from '../_enums/notificationreport';
import { AppConfig, DataService, ExcelService, PreviousRouteService } from '../_helpers';
import { BackFilterService, CommonDataService, CustomerService, ExcelDateConvertService, NotificationService } from '../_services';
import { QueryParamsReportsNotificationsList } from '../_models/queryparamslist.interface';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';

@Component({
  selector: 'app-notificationreportlist',
  templateUrl: './notificationreportlist.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})
export class NotificationReportListComponent implements OnInit {
  public customer_public_id: string;
  public customer_Account_public_id: string;
  isRangoVisiable = false;
  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  isSubCustomerId: boolean;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  public fromDate: any;
  public toDate: any;
  tempStatus: any;
  tempType: any;
  filterValue: any;
  searchValue: any;
  public ddlfilterPerChannel: any[] = []
  public ddlnotificationCreation: any[] = [];
  public ddlStatus: any[] = [];
  displayedColumns = [];
  TotalResultSize: any;
  pageSize: any;
  PageSizeOptions: number[];
  pageIndex: number = 0;
  pageStart: number = 0;
  excelExportData: any;
  dataSourceNotificationReportList = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  search_by = "created";
  notificationProperties: any;
  notificationPropertiesLabelName = "";
  notificationServicesConfiguration: any;
  columnsToDisplay: string[] = [];
  availableColumns = [];
  tableField: { label: string, value: string }[] = [];
  hardCodeTable = false;
  dynamicTable = false;
  hardCodeStatus = false;
  dynamicStatus = false;
  kashioApplication: any;

  filterByDropdownValue = 'created';
  creationDropdownValue = 3;
  statusDropdownValue = 'TODOS';
  filterChannelDropdownValue = 0;
  filterByFormControl = new FormControl('created');
  creationFormControl = new FormControl(3);
  statusFormControl = new FormControl('TODOS');
  filterChannelFormControl = new FormControl(0)
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  queryParams: QueryParamsReportsNotificationsList = {};
  snapshotQueryParam: QueryParamsReportsNotificationsList = {};
  startDateFromSnapshotQueryParam: boolean = false;
  endDateFromSnapshotQueryParam: boolean = false;

  constructor(private router: Router, private formBuilder: FormBuilder,
    private _fb: FormBuilder, private datePipe: DatePipe, private notificationService: NotificationService,
    private spinnerService: Ng4LoadingSpinnerService, private excelService: ExcelService, private commonDataService: CommonDataService,
    private notificationReportCreation: NotificationReportCreation, private notificationReportStatus: NotificationReportStatus, private notificationReportChannel: NotificationReportChannel,
    private customerService: CustomerService, private dataService: DataService,
    private backFilterService:BackFilterService, private previousRouteService:PreviousRouteService, private excelDateConvertService:ExcelDateConvertService
    , private activatedRoute: ActivatedRoute
    ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.commonDataService.getNotificationPropertiesSharedData().subscribe(data => this.notificationProperties = data);
    this.commonDataService.getNotificationServicesConfigurationSharedData().subscribe(data => this.notificationServicesConfiguration = data);
    this.ddlStatus = this.notificationReportStatus.status;
    this.ddlfilterPerChannel = this.notificationReportChannel.channel;
    this.ddlnotificationCreation = this.notificationReportCreation.creation;
    // back to search start
    this.backFilterService.getNotificationSearchSharedData().subscribe(data => this.backToSearchSharedData = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
    // back to search end
  }

  ngOnInit() {
    this.spinnerService.show();
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.isSubCustomerId = false;
        this.customer_public_id = localStorage.getItem('companyId');
      }
    }
    else {

      if (localStorage.getItem('subcompanyId') == 'undefined') {
        this.customer_public_id = localStorage.getItem('companyId');
        this.isSubCustomerId = false;
      }

      else {
        this.customer_public_id = localStorage.getItem('subcompanyId');
        this.isSubCustomerId = true;
      }

    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    this.kashioApplication = localStorage.getItem('application');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    // }
    this.hardCodeDisplayColumn();
    this.getNotificationProperties();

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });


    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    if (this.ddlnotificationCreation.length > 8) {
      this.ddlnotificationCreation.shift();
    }
    this.fromDate = this.setTodayValueFilter('00:00:00');
    this.toDate = this.setTodayValueFilter('23:59:59');
    this.tempStatus = 'all';
    this.tempType = 'all';
    this.searchValue = "";

     //back to search start
     this.previousUrl = this.previousRouteService.getPreviousUrl();

     let route = "";
     const application = localStorage.getItem('application');
     if (AccountTypeOptions[application] != undefined) {
       route = AccountTypeOptions[application];
     }

     if ((this.isBrowserBackButtonPressed == true) &&
       (this.previousUrl.includes(`/${route}/invoices/`)) &&
       (this.previousUrl.includes("/view"))
     ) {
       this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
       this.setBackToSearchData();
     }else{
       this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
       this.backFilterService.setInvoiceSearchSharedData(null);
     }
     //back to search end

     this.searchFilterForm = this.formBuilder.group({
       searchText: [this.searchValue, Validators.required]
     });
    this.getNotificationServicesConfiguration().then(res => this.getNotificationReportList());
    this.setBackToSearchFilter();
  }

  setBackToSearchData(){
    if (this.backToSearchSharedData != null) {
      this.searchValue = this.backToSearchSharedData.search;
      this.search_by = this.backToSearchSharedData.search_by;
      this.tempType = this.backToSearchSharedData.tempType;
      this.tempStatus = this.backToSearchSharedData.tempStatus;
      this.creationDropdownValue = this.backToSearchSharedData.creationDropdownValue;
      this.filterByDropdownValue = this.backToSearchSharedData.filterByDropdownValue;
      this.statusDropdownValue = this.backToSearchSharedData.statusDropdownValue;
      this.filterChannelDropdownValue = this.backToSearchSharedData.filterChannelDropdownValue;

      this.creationFormControl.setValue(this.backToSearchSharedData.creationDropdownValue);
      this.filterByFormControl.setValue(this.filterByDropdownValue);
      this.statusFormControl.setValue(this.statusDropdownValue);
      this.filterChannelFormControl.setValue(this.filterChannelDropdownValue);
      this.dynamicTable = this.backToSearchSharedData.dynamicTable;
      this.hardCodeTable = this.backToSearchSharedData.hardCodeTable;
      this.displayedColumns = this.backToSearchSharedData.displayedColumns;
      this.columnsToDisplay = this.backToSearchSharedData.columnsToDisplay;
      this.pageSize = this.backToSearchSharedData.pageSize;
      this.pageIndex = this.backToSearchSharedData.pageIndex;
      this.pageStart = this.backToSearchSharedData.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      if (this.backToSearchSharedData.creationDropdownValue == 8) {
        this.searchRangoFilterForm = this._fb.group({
          searchFromDate: [this.backToSearchSharedData.searchFromDate],
          searchToDate: [this.backToSearchSharedData.searchToDate]
        });
        this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
        this.ddlnotificationCreation.unshift({ value: 8, name: this.filterValue });
        this.isRangoVisiable = false;
        this.fromDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
        this.toDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
        this.creationFormControl.setValue(8);
        this.creationDropdownValue = 8;
      }else{
        this.fromDate = this.backToSearchSharedData.creationStartDate;
        this.toDate = this.backToSearchSharedData.creationEndDate;
      }

      this.setBackToSearchFilter();
    }
  }

  hardCodeDisplayColumn() {
    if (this.kashioApplication == 'CORPORATE') {
      this.displayedColumns = ['customer.name', 'metadata.invoice.external_id', 'type', 'created', 'header', 'sender', 'recipient.0', 'status'];
    } else {
      this.displayedColumns = ['metadata.invoice.external_id', 'type', 'created', 'header', 'sender', 'recipient.0', 'status'];
    }
  }

  getNotificationReportList() {
    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length != 0) {

      let creationStateReportsNotificationsList = JSON.parse(localStorage.getItem('creationStateReportsNotificationsList'));
      let customCreationReportsNotificationsRange = localStorage.getItem('customCreationReportsNotificationsRange');

      if (this.snapshotQueryParam["pageIndex"] != undefined) {
        if (this.snapshotQueryParam["pageIndex"] != '') {
          this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
        } else {
          this.queryParams.pageIndex = this.pageIndex;
        }
      };

      if (this.snapshotQueryParam["pageSize"] != undefined) {
        if (this.snapshotQueryParam["pageSize"] != '') {
          this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
        } else {
          this.queryParams.pageSize = this.pageSize;
        }
      };

      if (this.snapshotQueryParam["startDate"] != undefined || this.snapshotQueryParam["endDate"] != undefined) {
        if (this.snapshotQueryParam["startDate"] != '' || (this.snapshotQueryParam["startDate"] == '' && creationStateReportsNotificationsList === 0)) {
          this.startDateFromSnapshotQueryParam = true;
          this.queryParams.startDate = this.snapshotQueryParam["startDate"].replace(' ', '-');
        } else {
          this.queryParams.startDate = this.fromDate;
        }

        if (this.snapshotQueryParam["endDate"] != '' || (this.snapshotQueryParam["endDate"] == '' && creationStateReportsNotificationsList === 0)) {
          this.endDateFromSnapshotQueryParam = true;
          this.queryParams.endDate = this.snapshotQueryParam["endDate"].replace(' ', '-');
        } else {
          this.queryParams.endDate = this.toDate;
        }

        if (creationStateReportsNotificationsList === 8) {
          this.creationFormControl.setValue(8);
          this.ddlnotificationCreation.unshift({ value: 8, name: customCreationReportsNotificationsRange });
        } else {
          this.creationFormControl.setValue(creationStateReportsNotificationsList);
        };
      };

      if (this.snapshotQueryParam["searchBy"] != undefined) {
        this.queryParams.searchBy = this.snapshotQueryParam["searchBy"];
        let columnName: string;
        this.setSearchByFormBySnapshotQueryParam(this.queryParams.searchBy, columnName);
        this.setColumnsByName(columnName);
      };

      if (this.snapshotQueryParam["type"] != undefined) {
        this.queryParams.type = this.snapshotQueryParam["type"];
        this.setTypeFormBySnapshotQueryParam(this.queryParams.type);
      };

      if (this.snapshotQueryParam["status"] != undefined) {
        this.queryParams.status = this.snapshotQueryParam["status"];
        this.setStatusFormBySnapshotQueryParam(this.queryParams.status);
      };

      if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] != '') {
        this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
        this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
      };

    this.pageEvent(this.queryParams);
    } else {
      this.spinnerService.show();
      localStorage.setItem('creationStateReportsNotificationsList', '3');
      this.notificationService.getNotificationReportList(this.customer_public_id, this.tempStatus, this.tempType, this.fromDate, this.toDate, this.pageSize, this.pageStart, this.searchValue, this.search_by).subscribe(data => {
        let resources = data["data"];
        this.dataSourceNotificationReportList.data = resources;
        this.TotalResultSize = data.records;
        this.spinnerService.hide();
      }, error => {
        this.spinnerService.hide();
        console.log('Failed! while trying to get the notification list. ' + error);
      })
    }
  }

  setStatusFormBySnapshotQueryParam(status) {
    switch (status) {
      case 'all':
        this.statusFormControl.setValue("TODOS");
        break;
      case '(0)':
        this.statusFormControl.setValue("SCHEDULED");
        break;
      case '(1)':
        this.statusFormControl.setValue("SENT");
        break;
      case '(2)':
        this.statusFormControl.setValue("DELIVERED");
        break;
      case '(3)':
        this.statusFormControl.setValue("OPENED");
        break;
      case '(4)':
        this.statusFormControl.setValue("VOIDED");
        break;
      case '(5)':
        this.statusFormControl.setValue("REJECTED");
        break;
      case '(6)':
        this.statusFormControl.setValue("PROCESSED");
        break;
      case '(7)':
        this.statusFormControl.setValue("RECEIVED");
        break;
      case '(8)':
        this.statusFormControl.setValue("CLICKED");
        break;
      case '(9)':
        this.statusFormControl.setValue("DEFERRED");
        break;
      case '(10)':
        this.statusFormControl.setValue("BOUNCED");
        break;
      case '(11)':
        this.statusFormControl.setValue("DROPPED");
        break;
      case '(12)':
        this.statusFormControl.setValue("SPAM");
        break;
      case '(13)':
        this.statusFormControl.setValue("UNDELIVERED");
        break;
      default:
        this.statusFormControl.setValue("TODOS");
    }
  }

  setSearchByFormBySnapshotQueryParam(searchBy, columnName) {
    switch (searchBy) {
      case 'created':
        columnName = "created";
        this.filterByFormControl.setValue("created");
        break;
      case 'scheduled':
        columnName = "scheduled";
        this.filterByFormControl.setValue("scheduled");
        break;
      default:
        columnName = "created";
        this.filterByFormControl.setValue("created");
    }
  }

  setTypeFormBySnapshotQueryParam(type) {
    switch (type) {
      case 'all':
        this.filterChannelFormControl.setValue(0);
        break;
      case '(0)':
        this.filterChannelFormControl.setValue(1);
        break;
      case '(1)':
        this.filterChannelFormControl.setValue(2);
        break;
      case '(2)':
        this.filterChannelFormControl.setValue(3);
        break;
      case '(3)':
        this.filterChannelFormControl.setValue(4);
        break;
      case '(4)':
        this.filterChannelFormControl.setValue(5);
        break;
      default:
        this.filterChannelFormControl.setValue(0);
    }
  }

  replaceAt(index, textToReplace, character) {
    let chars = textToReplace.split('');
    chars[index] = character;
    return chars.join('');
  }

  setColumnsByName(columnName) {
    if (this.dynamicTable) {
      if (columnName == "created") {
        this.displayColumn('scheduled');
      }
      if (columnName == "scheduled") {
        this.displayColumn('created');
      }
    }

    if (this.hardCodeTable) {
      if (this.kashioApplication == 'CORPORATE') {
        if (columnName == "created") {
          this.displayedColumns = ['customer.name', 'metadata.invoice.external_id', 'type', 'created', 'header', 'sender', 'recipient.0', 'status'];
        }

        if (columnName == "scheduled") {
          this.displayedColumns = ['customer.name', 'metadata.invoice.external_id', 'type', 'scheduled', 'header', 'sender', 'recipient.0', 'status'];
        }
      } else {
        if (columnName == "created") {
          this.displayedColumns = ['metadata.invoice.external_id', 'type', 'created', 'header', 'sender', 'recipient.0', 'status'];
        }

        if (columnName == "scheduled") {
          this.displayedColumns = ['metadata.invoice.external_id', 'type', 'scheduled', 'header', 'sender', 'recipient.0', 'status'];
        }
      }
    }
  }

  buildNotificationTable() {
    this.dynamicTable = true;
    var columns_report = this.notificationServicesConfiguration.values.columns_report.dictionary;
    this.availableColumns = columns_report.filter(item => item.status == true);
    for (var i = 0; i < this.availableColumns.length; i++) {
      if (Array.isArray(this.availableColumns[i].value)) {
        if (this.availableColumns[i].value.length > 0) {
          var temp_value = this.availableColumns[i].value[0].value.split('.');
          this.tableField.push({ label: this.availableColumns[i].label, value: temp_value[0] })
        }
      } else {
        this.tableField.push({ label: this.availableColumns[i].label, value: this.availableColumns[i].value });
      }
    }
    this.displayColumn('scheduled');
  }

  displayColumn(hideColumnName) {
    this.columnsToDisplay = [];
    for (var i = 0; i < this.tableField.length; i++) {
      if (this.tableField[i].value != hideColumnName) {
        this.columnsToDisplay.push(this.tableField[i].value)
      }
    }
  }

  displayValue(row, columnName) {
    var tempColumn = columnName.split(".");
    var obj = row;
    for (var i = 0; i < tempColumn.length; i++) {
      obj = obj[tempColumn[i]];
      if (obj == undefined) {
        return "";
        break;
      }
    }
    return obj;
  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit() {
    this.dataSourceNotificationReportList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourceNotificationReportList.sort = this.sort;
  }

  getNotificationReportListForFilter() {
    this.spinnerService.show();
    this.pageStart = 0;
    this.pageIndex = 0;
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize = this.pageSize;
    this.queryParams.startDate = this.fromDate;
    this.queryParams.endDate = this.toDate;
    this.queryParams.searchBy = this.search_by;
    this.queryParams.type = this.tempType;
    this.queryParams.status = this.tempStatus;
    if (this.searchValue != '') {
      this.queryParams.textSearch = this.searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.paginator.pageIndex = 0;
    this.setBackToSearchFilter();
    this.pageEvent(this.queryParams);
  }

  applyFilter() {
    this.searchValue = this.searchFilterForm.controls.searchText.value;
    this.searchValue = this.searchValue.trim().toLowerCase();
    this.getNotificationReportListForFilter();
    //this.setBackToSearchFilter();
  }

  filterRangoExpDetails() {

    if (this.ddlnotificationCreation.length > 8) {
      this.ddlnotificationCreation.shift();
    }
    if (this.searchRangoFilterForm.controls.searchFromDate.value != '' && this.searchRangoFilterForm.controls.searchToDate.value != '') {
      localStorage.setItem('creationStateReportsNotificationsList', '8');
      this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
      localStorage.setItem('customCreationReportsNotificationsRange', this.filterValue);
      this.ddlnotificationCreation.unshift({ value: 8, name: this.filterValue });
      this.isRangoVisiable = false;
      this.fromDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.toDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
      this.creationFormControl.setValue(8);
      this.creationDropdownValue = 8;
    }
    else {
      localStorage.setItem('creationStateReportsNotificationsList', '3');
      this.isRangoVisiable = false;
      this.creationFormControl.setValue(3);
      this.creationDropdownValue = 3;
      this.fromDate = this.setTodayValueFilter('00:00:00');
      this.toDate = this.setTodayValueFilter('23:59:59');
    }
    this.getNotificationReportListForFilter();
    //this.setBackToSearchFilter();
  }

  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  filterDateDetails(columnName) {
    this.search_by = columnName;
    this.filterByDropdownValue = columnName;
    this.dataSourceNotificationReportList.data = [];
    this.TotalResultSize = 0;
    if (this.dynamicTable) {
      if (columnName == "created") {
        this.displayColumn('scheduled');
      }
      if (columnName == "scheduled") {
        this.displayColumn('created');
      }
    }
    if (this.hardCodeTable) {
      if (this.kashioApplication == 'CORPORATE') {
        if (columnName == "created") {
          this.displayedColumns = ['customer.name', 'metadata.invoice.external_id', 'type', 'created', 'header', 'sender', 'recipient.0', 'status'];
        }

        if (columnName == "scheduled") {
          this.displayedColumns = ['customer.name', 'metadata.invoice.external_id', 'type', 'scheduled', 'header', 'sender', 'recipient.0', 'status'];
        }
      } else {
        if (columnName == "created") {
          this.displayedColumns = ['metadata.invoice.external_id', 'type', 'created', 'header', 'sender', 'recipient.0', 'status'];
        }

        if (columnName == "scheduled") {
          this.displayedColumns = ['metadata.invoice.external_id', 'type', 'scheduled', 'header', 'sender', 'recipient.0', 'status'];
        }
      }

    }
    this.getNotificationReportListForFilter();
    //this.setBackToSearchFilter();
  }

  filterChannelDetails(channel) {
    this.filterChannelDropdownValue = channel;
    if (channel == 0) {
      this.tempType = 'all';
      this.getNotificationReportListForFilter();
    }
    if (channel == 1) {
      this.tempType = '(0)';
      this.getNotificationReportListForFilter();
    }
    if (channel == 2) {
      this.tempType = '(1)';
      this.getNotificationReportListForFilter();
    }
    if (channel == 3) {
      this.tempType = '(2)';
      this.getNotificationReportListForFilter();
    }
    if (channel == 4) {
      this.tempType = '(3)';
      this.getNotificationReportListForFilter();
    }
    if (channel == 5) {
      this.tempType = '(4)';
      this.getNotificationReportListForFilter();
    }
    //this.setBackToSearchFilter();
  }

  filterCreationDetails(creation) {
    this.creationDropdownValue = creation;

    if (creation != 7) {
      localStorage.setItem('creationStateReportsNotificationsList', creation);
    };

    var currentDate = new Date();
    var currentDate1 = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(currentweekFirstDate.getDate() - 7);
    currentweekLastDate.setDate(currentweekLastDate.getDate() - (currentweekLastDate.getDay() - 1) + 6);


    // All Datas Condition
    if (creation == 0) {

      this.fromDate = "";
      this.toDate = "";
      this.getNotificationReportListForFilter()
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.fromDate = this.convertGMTTime(new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.toDate = this.convertGMTTime(new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
      this.fromDate = this.fromDate;
      this.toDate = this.toDate;
      this.getNotificationReportListForFilter();
    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.fromDate = this.convertGMTTime(new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.toDate = this.convertGMTTime(new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
      this.fromDate = this.fromDate;
      this.toDate = this.toDate;
      this.getNotificationReportListForFilter();
    }

    // Today Filter Condition
    if (creation == 3) {
      currentDate.setDate(currentDate.getDate());
      this.fromDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.toDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
      this.fromDate = this.fromDate;
      this.toDate = this.toDate;
      this.getNotificationReportListForFilter();
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      currentDate.setDate(currentDate.getDate() - 1);
      this.fromDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.toDate = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
      this.fromDate = this.fromDate;
      this.toDate = this.toDate;
      this.getNotificationReportListForFilter();
    }

    // Last Week Filter Condition
    if (creation == 5) {
      this.fromDate = this.convertGMTTime(new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.toDate = this.convertGMTTime(new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
      this.fromDate = this.fromDate;
      this.toDate = this.toDate;
      this.getNotificationReportListForFilter();
    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.fromDate = this.convertGMTTime(new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
      this.toDate = this.convertGMTTime(new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
      this.fromDate = this.fromDate;
      this.toDate = this.toDate;
      this.getNotificationReportListForFilter();
    }
    if (creation == 7) {

      this.isRangoVisiable = true;
    }
    else {
      this.isRangoVisiable = false;
    }
    if (creation == 8) {
      this.filterRangoExpDetails()
    }

    this.setBackToSearchFilter();
  }

  filterStatusDetails(status) {
    this.statusDropdownValue = status;
    if (status == "TODOS") {
      this.tempStatus = 'all';
    }
    if (status == "SCHEDULED") {
      this.tempStatus = '(0)';
    }
    if (status == "SENT") {
      this.tempStatus = '(1)';
    }
    if (status == "DELIVERED") {
      this.tempStatus = '(2)';
    }
    if (status == "OPENED") {
      this.tempStatus = '(3)';
    }
    if (status == "VOIDED") {
      this.tempStatus = '(4)';
    }
    if (status == "REJECTED") {
      this.tempStatus = '(5)';
    }
    if (status == "PROCESSED") {
      this.tempStatus = '(6)';
    }
    if (status == "RECEIVED") {
      this.tempStatus = '(7)';
    }
    if (status == "CLICKED") {
      this.tempStatus = '(8)';
    }
    if (status == "DEFERRED") {
      this.tempStatus = '(9)';
    }
    if (status == "BOUNCED") {
      this.tempStatus = '(10)';
    }
    if (status == "DROPPED") {
      this.tempStatus = '(11)';
    }
    if (status == "SPAM") {
      this.tempStatus = '(12)';
    }
    if (status == "UNDELIVERED") {
      this.tempStatus = '(13)';
    }
    this.getNotificationReportListForFilter();
  }
  pageEvent(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    let creationStateReportsNotificationsList = JSON.parse(localStorage.getItem('creationStateReportsNotificationsList'));

    if (event["startDate"] || (event["startDate"] == '' && creationStateReportsNotificationsList == 0)) {
      if (this.startDateFromSnapshotQueryParam == true && creationStateReportsNotificationsList != 0) {
        this.queryParams.startDate = event["startDate"];
        this.fromDate = this.replaceAt(10, event["startDate"], ' ');
        this.startDateFromSnapshotQueryParam = false;
      } else {
        this.fromDate = event["startDate"];
        this.queryParams.startDate = event["startDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.startDate = this.fromDate.replace(' ', '-');
    };

    if (event["endDate"] || (event["endDate"] == '' && creationStateReportsNotificationsList == 0)) {
      if (this.endDateFromSnapshotQueryParam == true && creationStateReportsNotificationsList != 0) {
        this.queryParams.endDate = event["endDate"];
        this.toDate = this.replaceAt(10, event["endDate"], ' ');
        this.endDateFromSnapshotQueryParam = false;
      } else {
        this.toDate = event["endDate"];
        this.queryParams.endDate = event["endDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.endDate = this.toDate.replace(' ', '-');
    };

    if (event["searchBy"]) {
      this.queryParams.searchBy = event["searchBy"];
      this.search_by = this.queryParams.searchBy;
    } else {
      this.queryParams.searchBy = this.search_by;
    };

    if (event["type"]) {
      this.queryParams.type = event["type"];
      this.tempType = this.queryParams.type;
    } else {
      this.queryParams.type = this.tempType;
    };

    if (event["status"]) {
      this.queryParams.status = event["status"];
      this.tempStatus = this.queryParams.status;
    } else {
      this.queryParams.status = this.tempStatus;
    };

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      skipLocationChange: false,
      replaceUrl: true
    });

    this.notificationService.getNotificationReportList(this.customer_public_id, this.tempStatus, this.tempType, this.fromDate, this.toDate, this.pageSize, this.pageStart, this.searchValue, this.search_by).subscribe(data => {
      let resources = data["data"];
      this.dataSourceNotificationReportList.data = resources;
      this.TotalResultSize = data.records;
      this.spinnerService.hide();
    }, error => {
      this.spinnerService.hide();
        console.log('Failed! while trying to get the notification list. ' + error);
      })
      this.setBackToSearchFilter();
  }

  exportAsXLSX() {
    this.spinnerService.show();
    this.notificationService.getNotificationReportList(this.customer_public_id, this.tempStatus, this.tempType, this.fromDate, this.toDate, '10000', 0, this.searchValue, this.search_by).subscribe(data => {
      let resources = data["data"];
      this.excelExportData = resources;
      if (this.dynamicTable == true) {
        this.setExportExcelFileDataNew(this.excelExportData);
      }

      if (this.hardCodeTable == true) {
        this.setExportExcelFileData(this.excelExportData);
      }
      this.spinnerService.hide();
    },
      error => {
        console.log('Failed! while trying to get the notification list. ' + error);
      })
  }

  setExportExcelFileDataNew(excelExportData) {
    var header = this.availableColumns.map(item => item.label);
    header = header.map(item => item.toUpperCase())
    var arrFinalData = [];
    for (var i = 0; i < excelExportData.length; i++) {
      var tempSingleData = excelExportData[i];
      var tempArray = [];
      for (var j = 0; j < this.tableField.length; j++) {
        // Created  Data Start
        if (this.tableField[j].value == 'created') {
          var tempCreatedDateValue;
          var tempCreatedDateFinalValue;
          tempCreatedDateValue = this.getValueFromObj(tempSingleData, this.tableField[j].value);
          tempCreatedDateFinalValue = this.excelDateConvertService.convertExcelDateTime(tempCreatedDateValue);
          tempArray.push(tempCreatedDateFinalValue);
        }
        //Created  Data End

        // Scheduled Data Start
        else if (this.tableField[j].value == 'scheduled') {
          var tempScheduledDateValue;
          var tempScheduledDateFinalValue;
          tempScheduledDateValue = this.getValueFromObj(tempSingleData, this.tableField[j].value);
          if (tempScheduledDateValue == 'None') {
            tempScheduledDateFinalValue = this.excelDateConvertService.convertExcelDateTime(this.getValueFromObj(tempSingleData, 'created'));
          } else {
            tempScheduledDateFinalValue = this.excelDateConvertService.convertExcelDateTime(this.getValueFromObj(tempSingleData, this.tableField[j].value));
          }
          tempArray.push(tempScheduledDateFinalValue);
        }
        //Scheduled Data End

        //Recipients Data Start
        else if (this.tableField[j].value == 'recipients') {
          var tempRecipients = tempSingleData['type'];
          var tempRecipientsValue = "";
          switch (tempRecipients) {
            case 'EMAIL':
              tempRecipientsValue = tempSingleData[this.tableField[j].value][0].email;
              break;
            case 'WHATSAPP':
              tempRecipientsValue = tempSingleData[this.tableField[j].value][0].phone;
              break;
            case 'SMS':
              tempRecipientsValue = tempSingleData[this.tableField[j].value][0].phone;
              break;
            case 'WEBHOOK':
              tempRecipientsValue = tempSingleData[this.tableField[j].value][0].webhook;
              break;
            default:
              tempRecipientsValue = "";
          }
          tempArray.push(tempRecipientsValue);
        }
        //Recipients Data End

        //Status Data Start
        else if (this.tableField[j].value == 'status') {
          var tempStatus = "";
          var tempStatusFinal = "";
          tempStatus = this.getValueFromObj(tempSingleData, this.tableField[j].value);
          tempStatusFinal = this.statusNameToSpanish(tempStatus);
          tempArray.push(tempStatusFinal);
        }
        //Status Data End

        else {
          var tempOtherData = "";
          tempOtherData = this.getValueFromObj(tempSingleData, this.tableField[j].value);
          tempArray.push(tempOtherData);
        }
        //Scheduled Data End

      }
      arrFinalData.push(tempArray);
    }
    this.excelService.generateNotificationExcelFile(header, arrFinalData, 'NotificationList');
  }

  getValueFromObj(row, columnName) {
    var tempColumn = columnName.split(".");
    var obj = row;
    for (var i = 0; i < tempColumn.length; i++) {
      obj = obj[tempColumn[i]];
      if (obj == undefined) {
        return "";
        break;
      }
    }
    return obj;
  }

  setExportExcelFileData(excelExportData) {
    var excelHeader;
    if (this.kashioApplication == 'CORPORATE') {
      excelHeader = ["Empresa", "REFERENCIA DE ORDEN", "CANAL", "FECHA DE CREACIÓN", "FECHA DE PROGRAMACIÓN", "ASUNTO", "ENVIADO POR", "RECIBIDO POR", "ESTADO"];
    } else {
      excelHeader = ["REFERENCIA DE ORDEN", "CANAL", "FECHA DE CREACIÓN", "FECHA DE PROGRAMACIÓN", "ASUNTO", "ENVIADO POR", "RECIBIDO POR", "ESTADO"];

    }
    var arrFinalData = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];

    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];
      columnsKeyNames = Object.keys(singleRec_temp);
      var customer_temp, type_temp, created_temp, subject_temp, sender_temp, recipient_temp, status_temp, invoice_external_id_temp, scheduled_temp;
      object_temp = {};
      var scheduled_date_temp;
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == "customer") {
          customer_temp = singleRec_temp[columnsKeyNames[j]].name;
        }
        if (columnsKeyNames[j] == "type") {
          type_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "metadata") {
          if (singleRec_temp[columnsKeyNames[j]].hasOwnProperty('invoice') && singleRec_temp[columnsKeyNames[j]].invoice.external_id != undefined) {
            invoice_external_id_temp = singleRec_temp[columnsKeyNames[j]].invoice.external_id;
          } else {
            invoice_external_id_temp = "";
          }
        }
        else if (columnsKeyNames[j] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "scheduled") {
          scheduled_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "header") {
          subject_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "sender") {
          sender_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "recipients") {
          var temp_type = singleRec_temp['type'];
          switch (temp_type) {
            case 'EMAIL':
              recipient_temp = singleRec_temp[columnsKeyNames[j]][0].email;
              break;
            case 'WHATSAPP':
              recipient_temp = singleRec_temp[columnsKeyNames[j]][0].phone;
              break;
            case 'SMS':
              recipient_temp = singleRec_temp[columnsKeyNames[j]][0].phone;
              break;
            case 'WEBHOOK':
              recipient_temp = singleRec_temp[columnsKeyNames[j]][0].webhook;
              break;
            default:
              recipient_temp = "";
          }

        }
        else if (columnsKeyNames[j] == "status") {
          var temp_status = singleRec_temp[columnsKeyNames[j]];
          switch (temp_status) {
            case "SCHEDULED":
              status_temp = 'Programado'
              break;
            case "SENT":
              status_temp = 'Enviado'
              break;
            case "DELIVERED":
              status_temp = 'Entregado'
              break;
            case "OPENED":
              status_temp = 'Abierto'
              break;
            case "VOIDED":
              status_temp = 'Anulado'
              break;
            case "REJECTED":
              status_temp = 'Rechazado'
              break;
            case "PROCESSED":
              status_temp = 'Procesado'
              break;
            case "RECEIVED":
              status_temp = 'Recibido'
              break;
            default:
              status_temp = temp_status;
          }
        }
      }
      if (scheduled_temp != 'None') {
        scheduled_date_temp = this.excelDateConvertService.convertExcelDateTime(scheduled_temp);
      } else {
        scheduled_date_temp = this.excelDateConvertService.convertExcelDateTime(created_temp);
      }
      if (this.kashioApplication == 'CORPORATE') {
        arrFinalData.push([customer_temp, invoice_external_id_temp, type_temp, this.excelDateConvertService.convertExcelDateTime(created_temp),
          scheduled_date_temp, subject_temp, sender_temp, recipient_temp, status_temp]);
      }else{
        arrFinalData.push([invoice_external_id_temp, type_temp, this.excelDateConvertService.convertExcelDateTime(created_temp),
          scheduled_date_temp, subject_temp, sender_temp, recipient_temp, status_temp]);
      }
    }
    this.excelService.generateKashioExcelFile(excelHeader,arrFinalData, 'NotificationList');
  }

  viewInvoice(id) {
    if (id != undefined && id !== "") {
      const application = localStorage.getItem('application');
      if (AccountTypeOptions[application] != undefined) {
        this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${id}/view`]);
      }
    }
  }

  async getNotificationProperties() {
    if (this.notificationProperties == null) {
      try {
        const data = await this.notificationService.getNotificationProperties(this.customer_public_id);
        this.commonDataService.setNotificationPropertiesSharedData(data);
        this.notificationProperties = data;
        this.setNotificationProperties();
      }
      catch (error) {
        if (error.status == 404) {
          this.hardCodeStatus = true;
        } else {
          console.log('Failed while trying to get the notification properties.' + error.error)
        }
      }
    } else {
      this.setNotificationProperties();
    }

  }

  setNotificationProperties() {
    this.dynamicStatus = true;
    this.ddlStatus = this.notificationProperties.values.property_list.status.dictionary;
    this.notificationPropertiesLabelName = this.notificationProperties.values.property_list.status.label
  }

  statusNameToSpanish(value) {
    if (this.notificationProperties != null) {
      var tempValue = this.ddlStatus.filter(data => data.value == value);
      if (tempValue.length > 0) {
        return tempValue[0].label;
      }
      return "";
    } else {
      return value;
    }
  }

  async getNotificationServicesConfiguration() {
    if (this.notificationServicesConfiguration == null) {
      try {
        const data = await this.notificationService.getNotificationServicesConfiguration(this.customer_public_id);
        this.commonDataService.setNotificationServicesConfigurationSharedData(data);
        this.notificationServicesConfiguration = data;
        //if dynamic report is not configured then show the hardcode table
        if(this.notificationServicesConfiguration.values.columns_report !== undefined){
          this.buildNotificationTable();
        }else{
          this.hardCodeTable = true;
        }
      }
      catch (error) {
        if (error.status == 404) {
          this.hardCodeTable = true;
        } else {
          console.log('Failed while trying to get the notification services configuration.' + error.error)
        }
      }
    } else {
      //if dynamic report is not configured then show the hardcode table
      if(this.notificationServicesConfiguration.values.columns_report !== undefined){
        this.buildNotificationTable();
      }else{
        this.hardCodeTable = true;
      }
    }
  }

  viewDashboard(element) {
    localStorage.setItem('isCorporateCompany', "Yes");
    localStorage.removeItem('accessmenu');
    this.GetSubCompanyName(element);
    localStorage.setItem('subcompanyId', element.customer.public_id);
    this.router.navigate([`/dashboardcallback`]);
  }

  GetSubCompanyName(element) {

    this.customerService.getCustomerCompanyDetailsList(element.customer.public_id).subscribe(d => {
      localStorage.setItem('isCorporate', 'Yes');
      localStorage.setItem('customername', d.body.name);
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));
    },
      error => {
        console.log('Failed! while trying to get the SubCompanyName. ' + error);
      });

  }

  setBackToSearchFilter(){
    this.tempSearch = {
      search: this.searchValue,
      creationStartDate: this.fromDate,
      creationEndDate: this.toDate,
      search_by: this.search_by,
      tempType: this.tempType,
      tempStatus: this.tempStatus,
      creationDropdownValue: this.creationDropdownValue,
      filterByDropdownValue: this.filterByDropdownValue,
      statusDropdownValue: this.statusDropdownValue,
      filterChannelDropdownValue: this.filterChannelDropdownValue,
      searchFromDate: this.searchRangoFilterForm.controls.searchFromDate.value,
      searchToDate: this.searchRangoFilterForm.controls.searchToDate.value,
      dynamicTable: this.dynamicTable,
      hardCodeTable: this.hardCodeTable,
      displayedColumns: this.displayedColumns,
      columnsToDisplay: this.columnsToDisplay,
      pageSize: this.pageSize,
      pageIndex:this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setNotificationSharedData(this.tempSearch);
  }

  setTodayValueFilter(hour: string) {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    var todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }
}
